import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/workspace/components/AdComponent/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/workspace/components/AdComponent/TopPageAd.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/workspace/components/AdModal/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/workspace/components/GooglePreferredSource/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/workspace/components/NewsSection/NewsWithLoadMore.tsx");
;
import(/* webpackMode: "eager" */ "/home/app/workspace/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/app/workspace/node_modules/next/dist/client/image-component.js");
